module.exports = __webpack_public_path__ + "static/media/ecoFriendly.2d9801f8.svg";